import { AutomationChannel } from "@redotech/redo-model/advanced-flow/common";
import type { AiContextLibrary } from "@redotech/redo-model/ai-context-library";
import {
  AiContextLibrarySchema,
  qualityValues,
} from "@redotech/redo-model/ai-context-library";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const updateContextLibraryItemInputSchema_ = z.object({
  itemId: zExt.objectId(),
  updates: z
    .object({
      title: z.string().optional(),
      content: z.string().optional(),
      marketingAgentPromptIds: z.array(zExt.objectId()).optional(),
      smsTemplateId: zExt.objectId().optional(),
      channel: createEnum(AutomationChannelValues).optional(),
      quality: createEnum(qualityValues).optional(),
      feedback: z.string().optional(),
      useShopperAi: z.boolean().optional(),
      shopperAiDiscountId: zExt.objectId().nullish(),
    })
    .partial(),
});

export interface UpdateContextLibraryItemInput
  extends z.infer<typeof updateContextLibraryItemInputSchema_> {}
export const updateContextLibraryItemInputSchema: z.ZodType<UpdateContextLibraryItemInput> =
  updateContextLibraryItemInputSchema_;

export const updateContextLibraryItem = {
  name: "updateContextLibraryItem" as const,
  input: updateContextLibraryItemInputSchema,
  output: AiContextLibrarySchema as z.ZodType<AiContextLibrary>,
};
